export default {
    mounted() {
        var alertContent = document.createElement('p');
        alertContent.innerHTML=this.$i18nApi.t("noSolvent.message");
  
        this.$swal({
          content: alertContent,
          icon: 'warning',
          className: 'sweetalert-md',
          closeOnClickOutside: false,
          closeOnEsc: false,
          buttons: {
            back: {
              text: this.$i18nApi.t("noSolvent.backLabel"),
              value: 'back',
            },
            confirm: {
              text: this.$i18nApi.t("noSolvent.callLabel"),
              value: 'call',
              closeModal: false,
              color: '#fff'
            },
          },
        }).then((value) => {
          if (value === "back") {
            window.location.href = "/";
          }
    
          if (value === "call") {
            window.open('tel:'+this.$i18nApi.t("noSolvent.number"), '_system');
            window.location.href = "/";
          }
        }); 
    },
};
